import { Component, OnInit } from '@angular/core';
import { GlobalHelper } from 'src/app/services/Common/global.service';
import { LookupService } from 'src/app/Services/Common/lookup.service';
import { HrService } from 'src/app/services/hr/hr.service';
import { Ng4LoadingSpinnerService } from 'ng4-loading-spinner';

@Component({
  selector: 'app-salary-calculation',
  templateUrl: './salary-calculation.component.html',
  styleUrls: ['./salary-calculation.component.css']
})
export class SalaryCalculationComponent implements OnInit {
  Submitted: boolean = false;
  EmployeeSalaryList = [];
  EmployeeCategoryList = [];
  SalaryStatementList = [];
  PrintLoading = false;
  TotalNetAmount: any;

  constructor(private payrollService: HrService, private lookupservice: LookupService,
    public globalHelper: GlobalHelper, private spinnerService: Ng4LoadingSpinnerService) { }

  SalaryCalculationModel = {
    MonthID: 0,
    PaymentModeID: 0,
    EmployeeCategoryID: 0,
    PrimaryDepartmentID: 0,
    Print: '',
    StaffIdentity:'',

  }

  FieldValidation() {
    return this.SalaryCalculationModel.MonthID == 0;
  }

  SaveGenrate() {

    if (!this.FieldValidation()) {
      this.spinnerService.show();
      this.payrollService.SaveGenrate(JSON.stringify(this.SalaryCalculationModel)).subscribe((data: any) => {
        this.globalHelper.CheckActionStatus(data);
        this.spinnerService.hide();
        if (data.webResponse.Status) {
          this.GetStaffSalary();
        }
      });
    }
  };

  SavePayCash(obj) {
    this.payrollService.SavePayCash(this.SalaryCalculationModel.MonthID, JSON.stringify(this.EmployeeSalaryList)).subscribe((data: any) => {
      this.globalHelper.CheckActionStatus(data);
      if (data.webResponse.Status) {
        // this.SearchGenrate();
      }
    });
  };


  GetStaffSalary() {
    this.Submitted = true;
    if (!this.FieldValidation()) {
      this.spinnerService.show();
      this.SalaryCalculationModel.Print = '';
      this.payrollService.GetStaffSalary(JSON.stringify(this.SalaryCalculationModel)).subscribe((data: any) => {
        this.EmployeeSalaryList = data.EmployeeSalaryList;
        this.Submitted = false;
        this.spinnerService.hide();
      });
    }
  };

 

  YearList = [];

  ngOnInit() {
    this.GetAllPaymentMode();
    this.GetEmployeeCategory();
    this.GetSalaryMonth();
    this.GetDepartment();

  }

  PaymentModeList = [];
  GetAllPaymentMode() {
    this.lookupservice.GetLookupsList('SALARYPaymentMode', '').subscribe((data: any) => {
      this.PaymentModeList = data.LookupItems;

    });

  }
  SalaryMonthList = [];
  GetSalaryMonth() {
    this.lookupservice.GetLookupsList('SalaryMonth', '').subscribe((data: any) => {
      this.SalaryMonthList = data.LookupItems;
    });
  };
  GetEmployeeCategory() {
    this.lookupservice.GetLookupsList('EmployeeCategory', '').subscribe((data: any) => {
      this.EmployeeCategoryList = data.LookupItems;
    });
  };

  ListDepartment = []
  GetDepartment() {
    this.lookupservice.GetLookupsList('Department', '').subscribe((data: any) => {
      this.ListDepartment = data.LookupItems;
    });

  }



  GetSalaryID(SalaryID) {
    var url = "staffsalaryprint?SalaryID=" + SalaryID;
    this.globalHelper.OpenPopUpWindow(url, "yes", "950", "1000");

  }


  SaveGenrateFinal() {
    this.Submitted = true;
    if (!this.FieldValidation()) {
      this.Submitted = false;
      this.payrollService.SaveGenrateFinal(JSON.stringify(this.SalaryCalculationModel), JSON.stringify(this.EmployeeSalaryList)).subscribe((data: any) => {
        this.globalHelper.CheckActionStatus(data);
        if (data.webResponse.Status) {
          this.GetStaffSalary();
        }
      });
    }
  };

  // Salary List


  GetStaffSalaryDownload() {
    this.Submitted = true;
    if (!this.FieldValidation()) {
      this.spinnerService.show();
      this.SalaryCalculationModel.Print = 'XLS';
      this.payrollService.GetStaffSalary(JSON.stringify(this.SalaryCalculationModel)).subscribe((data) => {
        this.spinnerService.hide();
        this.Submitted = false;
        // this.FilePath = data.FilePath;
        window.location = data.FilePath;

      });
    }
  };

  GetStaffSalaryPrint() {
    this.Submitted = true;
    if (!this.FieldValidation()) {
      var url = "salarylistprint?EmployeeCategoryID=" + this.SalaryCalculationModel.EmployeeCategoryID + '&MonthID=' + this.SalaryCalculationModel.MonthID + '&PaymentModeID=' + this.SalaryCalculationModel.PaymentModeID + '&PrimaryDepartmentID=' + this.SalaryCalculationModel.PrimaryDepartmentID;
      this.globalHelper.OpenPopUpWindow(url, "yes", "950", "1000");
      this.Submitted = false;
    }
  }

}
